import React, { useEffect } from "react";
import { useCreditDispatch } from "../../../stores/credit/credit.store";
import { fetchShippingMethodsThunk } from "../../../stores/credit/thunks/fetch-shipping-methods.thunk";
import { Methods } from "./Methods";
import { CreditState } from "../../../stores/credit/credit-state.interface";
import { ShippingForm } from "./ShippingForm";
import { useCreditSelector } from "../../../stores/product/product.store";

export const Shippings: React.FC = () => {
    const shippingMethods = useCreditSelector((state: CreditState) => state.shipping.shippingMethods);
    const dispatch = useCreditDispatch();

    useEffect(() => {
        dispatch(fetchShippingMethodsThunk())
    }, [dispatch]);

    return (
        <>
            { shippingMethods && <Methods methods={ shippingMethods } /> }
            <div className="mt-2">
                <ShippingForm />
            </div>
        </>
    )
}